(function (document) {
    "use strict";

    const counterSpan = document.querySelector("#noSelected");
    const statementIdsInput = document.querySelector("#statement-ids");

    function countCheckboxes() {
      // Count number selected and update counter
      let totalSelected = 0;
      let selectedStatements = [];
      statementIdsInput.value = "";
      document.querySelectorAll("input.check-select").forEach(item => {
        if (item.checked) {
          totalSelected += 1;
          let statementID = item.getAttribute("data-statement-id");
          if(statementID){
            selectedStatements.push(statementID);
          }
        }
      });
      statementIdsInput.value = selectedStatements.join(",");
      return totalSelected
    }

    // Add event handlers
    document.querySelectorAll(".check-select-all").forEach(item => {
      item.addEventListener("change", event => {
        document.querySelectorAll(".check-select").forEach(item => {
          if (item.disabled !== true) {
            item.checked = event.target.checked;
          }
        });
        counterSpan.innerHTML = countCheckboxes();
      });
    });

    document.querySelectorAll(".check-select").forEach(item => {
      item.addEventListener("change", event => {
        counterSpan.innerHTML = countCheckboxes();
      });
    });
})(document);
